module.exports = __webpack_public_path__ + "static/img/xueshu4.fc8e945d.webp";